import {Component, ViewChild} from '@angular/core';
import {Chunker} from '../framework/chunker';
import {QARService} from '../services/qar.service';
import {AppUser} from '../framework/AppUser';
import {UITableComponent} from '../framework/ui/table';

@Component({
	selector: 'app-page-audit-log',
	templateUrl: 'audit-log.html',
	providers: [QARService, AppUser]
})
export class PageAuditLogComponent {

	@ViewChild('tableReportRows', {static: false}) tableReportRows: UITableComponent;

	constructor(public api: QARService, public user: AppUser) {
	}

	public logs = {
		loading: false,
		data: {
			dateTo: this.helper_todaysDate(),
			dateFrom: this.helper_todaysDate()
		},
		selected: null,
		selectedId: null,
		deleting: {},
		chunker: (new Chunker([])),
		chunkedData: [],
		tableHeaders: [
			{id: 'Id', label: 'Id', filterable: true},
			{id: 'Path', label: 'Path', filterable: true},
			{id: 'Log', label: 'Log', filterable: true},
			{
				id: 'HasError', label: 'Has Error', filterable: true, idFunction: this.helper_idFunctionHasError, type: 'dropdown',
				options: {
					choices: {
						OK: 'OK', Error: 'Error'
					}, emptyChoiceText: '(Has Error)'
				}
			},
			{id: 'CreatedDate', label: 'Created Date'},
			{
				label: 'Json Data', type: 'dropdown', filterable: true,
				idFunction: this.helper_idFunctionJson,
				options: {
					choices: {
						0: 'No Json', 1: 'Json'
					}, emptyChoiceText: '(Json Data)'
				}
			},
		],

	};

	public helper_idFunctionJson(row) {
		return row.Json && row.Json != '{}' ? 1 : 0;
	}

	public helper_idFunctionHasError(row) {
		return row['HasError'] == true ? 'Error' : 'OK';
	}

	public newJson = {
		modalHidden: true,
		message: null,
		sending: false
	};

	public newsoruserchanges = {
		modalHidden: true,
		message: null,
		sending: false
	};

	selected_JsonData: any = null;

	public newJson_open(row: any) {
		this.selected_JsonData = row;
		this.newJson.modalHidden = false;
	}

	selected_sor_user_changes: any = null;

	public newsoruserchanges_open(row: any) {
		this.selected_sor_user_changes = row;
		this.newsoruserchanges.modalHidden = false;
	}


	public search() {
		console.log(this.logs.data.dateTo);
		this.logs.loading = true;
		this.api.retrieveQARAuditLogsFilter(this.logs.data.dateTo, this.logs.data.dateFrom).then(r => {
			this.logs.loading = false;
			this.logs.chunker = new Chunker(r);
		});
	}

	public helper_beautifyJson(json) {
		return JSON.stringify(JSON.parse(json), null, 4);
	}

	public helper_todaysDate() {
		return this.helper_formatDate(new Date());
	}

	public helper_formatDate(date) {
		var d = new Date(date),
			month = '' + (d.getMonth() + 1),
			day = '' + d.getDate(),
			year = d.getFullYear();

		if (month.length < 2) {
			month = '0' + month;
		}
		if (day.length < 2) {
			day = '0' + day;
		}

		return [year, month, day].join('-');
	}

	public helper_dateRemoveOneDay(dateType) {
		var date = new Date(this.logs.data[dateType]);
		date.setDate(date.getDate() - 1);
		this.logs.data[dateType] = this.helper_formatDate(date);
		this.search();
	}

	public helper_dateAddOneDay(dateType) {
		var date = new Date(this.logs.data[dateType]);
		date.setDate(date.getDate() + 1);
		this.logs.data[dateType] = this.helper_formatDate(date);
		this.search();
	}
}
